module.exports = __webpack_public_path__ + "img/preview.ef1b3f69.png";